<template>
  <div class="subscriptions-page">
    <h2>Storico di {{ userName }}</h2>
    <router-link class="back-link" :to="{ name: 'admin.users' }">← Torna alla lista clienti</router-link>

    <!-- Filtro mesi -->
    <div class="filters">
      <label for="months-select">Intervallo di mesi:</label>
      <select id="months-select" v-model="monthsToShow" @change="fetchSubscriptions">
        <option v-for="m in [2, 4, 6, 12]" :key="m" :value="m">{{ m }} mesi</option>
      </select>
    </div>

    <p>📈 Lezioni completate dal 1º gennaio: <strong>{{ completedLessonsCount }}</strong></p>

    <p v-if="visibleSubscriptions.length === 0">⏳ Caricamento in corso...</p>

    <!-- Tabella iscrizioni -->
    <table v-else>
      <thead>
        <tr>
          <th>Nome Classe</th>
          <th>Data Classe</th>
          <th>Data Iscrizione</th>
          <th>Stato</th>
          <th>Pacchetto</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(sub, index) in visibleSubscriptions" :key="index">
          <td>{{ sub.class_name }}</td>
          <td>{{ sub.class_date }}</td>
          <td>{{ sub.subscription_date }}</td>
          <td>
            <span v-if="sub.b_dropped">❌ Persa (cancellazione tardiva)</span>
            <span v-else-if="sub.b_dropped2">⚠️ Cancellata in tempo</span>
            <span v-else-if="sub.status === 'future'">✅ Futuro</span>
            <span v-else>⏳ Passato</span>
          </td>
          <td>
            <span v-if="sub.product_name">
              {{ sub.product_name }}
              <small style="color: #aaa;">(#{{ sub.product_id }})</small><br>
              <small style="color: #888;">{{ sub.product_status }}</small>
            </span>
            <span v-else>–</span>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Carica altro -->
    <div class="pagination" v-if="visibleSubscriptions.length < filteredSubscriptions.length">
      <button @click="loadMore">Carica altre 20 ⬇</button>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'UserClassSubscriptions',
  data() {
    return {
      userId: null,
      userName: '',
      subscriptions: [],
      monthsToShow: 2,
      displayLimit: 20, // Visualizza 20 per volta
    }
  },
  computed: {
    filteredSubscriptions() {
      const cutoff = new Date()
      cutoff.setMonth(cutoff.getMonth() - this.monthsToShow)

      return this.subscriptions
        .filter(sub => new Date(sub.class_date) >= cutoff)
        .sort((a, b) => new Date(b.class_date) - new Date(a.class_date))
    },
    visibleSubscriptions() {
      return this.filteredSubscriptions.slice(0, this.displayLimit)
    },
    completedLessonsCount() {
      const jan1 = new Date(new Date().getFullYear(), 0, 1)
      return this.subscriptions.filter(sub =>
        new Date(sub.class_date) >= jan1 &&
        sub.status === 'past' &&
        !sub.b_dropped2 // ✅ esclude solo cancellazioni in tempo
      ).length
    }
  },
  created() {
    this.userId = this.$route.params.userid
    this.userName = this.$route.query.name || 'Utente'
    this.fetchSubscriptions()
  },
  methods: {
    async fetchSubscriptions() {
		this.displayLimit = 20
		try {
			const fromDate = new Date()
			fromDate.setMonth(fromDate.getMonth() - this.monthsToShow)
			const formattedDate = fromDate.toISOString().split('T')[0]

			const response = await api.admin().getUserClassSubscriptions(this.userId, { params: { from_date: formattedDate } })
			this.subscriptions = Array.isArray(response) ? response : response.data
		} catch (err) {
			console.error("Errore caricamento iscrizioni:", err)
			this.subscriptions = []
		}
	},
	loadMore() {
		this.displayLimit += 20
	}
  }
}
</script>

<style scoped>
.subscriptions-page {
  max-width: 900px;
  margin: auto;
  padding: 20px;
}
.filters {
  margin: 15px 0;
}
.filters select {
  margin-left: 8px;
  padding: 4px 8px;
}
.back-link {
  display: inline-block;
  margin-bottom: 20px;
  color: rgb(255, 224, 16);
  text-decoration: none;
  font-weight: bold;
}
.back-link:hover {
  text-decoration: underline;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
th, td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}
th {
  background: #f1f1f1;
  color: #222;
  font-weight: bold;
}
.pagination {
  text-align: center;
  margin-top: 20px;
}
.pagination button {
  padding: 8px 16px;
  font-weight: bold;
  border-radius: 6px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}
.pagination button:hover {
  background-color: #0056b3;
}
</style>
